import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper:{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
    },

    header: {
        color: theme.colors.grey_text,
        fontFamily: theme.font.secondary,
        display: 'flex',
        justifyContent: 'flex-start',
        minHeight: 64,
        flex: '0 0 64px',
        alignContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(3),
        padding: `${theme.spacing(3)} 0`,
        [theme.down('tablet')]: {
            minHeight: 'auto',
            flex: '0 0 auto',
            alignItems: 'flex-start',
            flexDirection: 'column',
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
    },
    filters: {
        display: 'flex',
        alignItems: 'center',
    },
    filterIcon: {
        color: theme.colors.violet_primary,
        cursor: 'pointer',
    },

    searchWrapper: {
        width: '100%',
        maxWidth: 312,
        [theme.down('mobile')]: {
            maxWidth: 'none',
        },
        marginRight: theme.spacing(4),
    },

    tabsContainer:{
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        flex: 1,
        minWidth: 0,
        [theme.down('tablet')]: {
            width: '100%',
            height: 'auto',
            justifyContent: 'flex-start',
        },
        [theme.down('mobile')]: {
            flexWrap: 'nowrap',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            overscrollBehaviorX: 'contain',
            paddingBottom: theme.spacing(1),
        },
    },
    tab: {
        border: 'none',
        background: 'none',
        outline: 'none',
        height: '40px',
        padding: '10px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        [theme.down('mobile')]: {
            padding: `${theme.spacing(1.5)}px ${theme.spacing(2)}px`,
            marginRight: 0,
        },
        ...flex('row', 'center', 'center'),
        color: theme.colors.blue_primary,
        borderRadius: '4px',
        marginRight: '15px',

        '&:disabled': {
            opacity: 0.3,
        },

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
        [theme.down('tablet')]: {
            marginRight: 0,
        },
    },
}));
